import { call, put, takeEvery } from "redux-saga/effects";
import { getPeopleListSuccess, getPeopleListFailure } from "src/Actions/People/peopleAction";
import { getPeopleList } from "src/Services/People/peopleApi";
import { findIfSingleAccount } from "src/Actions/Admin/adminActions";

// Constants
import { PEOPLE } from '../../Actions/People/types';

export default function* peopleSaga() {
  yield takeEvery(PEOPLE.GET_PEOPLE, fetchPeopleList);
}

export function* fetchPeopleList({ payload }) {
  try {
    let response = yield call(getPeopleList, payload);
    if (response && response.status === 200 && response.data) {
      let temp = response.data && response.data.length > 0 ? response.data : [];
      let val = (temp.length === 1 ? true : false) ;
      let isSingleAccount = temp && temp.length > 0 ? val : false;
      yield put(findIfSingleAccount(isSingleAccount));
      yield put(getPeopleListSuccess(response.data));
    }
  } catch (e) {
    yield put(getPeopleListFailure(e));
  }
}
